(function(){
  var FORM_ID='6a5726a3c721a0435db4beb9';
  var ROOT_ID='omnisend-form-'+FORM_ID;
  var OPTION_ORDER=[
    'Home Inspection',
    'HVAC',
    'Electrical Inspection',
    'Birdwatching',
    'Automotive Diagnostics',
    'Car Night Vision'
  ];

    var ICONS={
    'Home Inspection':'https://cdn.shopify.com/s/files/1/0872/5348/3804/files/2_70530cb9-b3de-4a36-a0a3-687de8f28af7.png?v=1784711580',
    'HVAC':'https://cdn.shopify.com/s/files/1/0872/5348/3804/files/4_6d13ad86-c638-4f91-b84a-108704c981a7.png?v=1784711580',
    'Electrical Inspection':'https://cdn.shopify.com/s/files/1/0872/5348/3804/files/5_584c6a1d-f283-400d-9948-54f22d4cc467.png?v=1784711580',
    'Birdwatching':'https://cdn.shopify.com/s/files/1/0872/5348/3804/files/6_c024c022-12c1-438f-9c08-5450bd2af32c.png?v=1784711580',
    'Automotive Diagnostics':'https://cdn.shopify.com/s/files/1/0872/5348/3804/files/3_a1324208-1ea1-4892-b5bc-e50f5f02e3ad.png?v=1784711580',
    'Car Night Vision':'https://cdn.shopify.com/s/files/1/0872/5348/3804/files/1_22b232bf-0714-4d0a-b3c8-75f1b941adf7.png?v=1784711580'
  };

  var scheduled=false;

  function normalize(value){
    return String(value||'').trim().toLowerCase();
  }

  function getRoot(){
    return document.getElementById(ROOT_ID)||document.querySelector('[id^="'+ROOT_ID+'-"]');
  }

  function directBlock(element,container){
    if(!element||!container)return null;
    var current=element;
    while(current.parentElement&&current.parentElement!==container){
      current=current.parentElement;
    }
    return current.parentElement===container?current:null;
  }

  function commonParent(elements){
    if(!elements.length)return null;
    var parent=elements[0].parentElement;
    while(parent&&!elements.every(function(element){return parent.contains(element);})){
      parent=parent.parentElement;
    }
    return parent;
  }

  function optionIndex(value){
    var normalized=normalize(value);
    for(var i=0;i<OPTION_ORDER.length;i+=1){
      if(normalize(OPTION_ORDER[i])===normalized)return i;
    }
    return OPTION_ORDER.length+100;
  }

  function syncInterest(label,input){
    label.classList.toggle('is-selected',Boolean(input.checked));
  }

  function markPanel(root,form){
    var panel=form.parentElement;
    while(panel&&panel!==root&&panel.getBoundingClientRect().width<480){
      panel=panel.parentElement;
    }
    if(!panel||panel===document.body)panel=root;
    panel.setAttribute('data-tm-popup-panel','');
    var content=panel.parentElement;
    if(content&&content!==document.body){
      content.setAttribute('data-tm-popup-content','');
    }
  }

    function hideNativeImages(container) {
    if (!container) return;

    Array.prototype.slice.call(container.children).forEach(function (child) {
        if (!child.querySelector) return;

        var images = Array.prototype.slice.call(
        child.querySelectorAll('img')
        );

        var hasNativeImage = images.some(function (image) {
        return !image.closest('.tm-ref-interest-icon');
        });

        if (
        hasNativeImage &&
        !child.querySelector('.tm-ref-banner')
        ) {
        child.setAttribute('data-tm-native-hidden', '');
        } else {
        child.removeAttribute('data-tm-native-hidden');
        }
    });
    }

  function markBlocks(root,container){
    var heading=directBlock(container.querySelector('h1,h2,h3'),container);
    var emailInput=root.querySelector('input[type="email"]');
    var email=directBlock(emailInput,container);
    var interestInput=root.querySelector('input[name="custom_energy_interests"]');
    var interest=directBlock(interestInput,container);
    var gdpr=root.querySelector('input[name="gdpr"]');
    var legal=directBlock(gdpr,container);
    var submit=root.querySelector('button[type="submit"]');
    var action=directBlock(submit,container);
    var descriptionParagraph=Array.prototype.slice.call(container.querySelectorAll('p')).filter(function(paragraph){
      return normalize(paragraph.textContent).indexOf('choose according to your energy')!==-1;
    })[0];
    var description=directBlock(descriptionParagraph,container);

    if(!description&&email&&interest){
      var current=email.nextElementSibling;
      while(current&&current!==interest){
        if(current.textContent&&normalize(current.textContent).indexOf('choose according')!==-1){
          description=current;
          break;
        }
        current=current.nextElementSibling;
      }
    }

    if(heading)heading.setAttribute('data-tm-heading-block','');
    if(email)email.setAttribute('data-tm-email-block','');
    if(description)description.setAttribute('data-tm-description-block','');
    if(interest)interest.setAttribute('data-tm-interest-block','');
    if(legal)legal.setAttribute('data-tm-legal-block','');
    if(action)action.setAttribute('data-tm-action-block','');

    var ordered=[heading,email,description,interest,legal,action].filter(Boolean);
    var children=Array.prototype.slice.call(container.children);
    var indexes=ordered.map(function(block){return children.indexOf(block);});
    var correct=indexes.every(function(index,position){
      return position===0||index>indexes[position-1];
    });

    if(!correct){
      ordered.forEach(function(block){container.appendChild(block);});
    }

    if(emailInput&&!emailInput.getAttribute('placeholder')){
      emailInput.setAttribute('placeholder','Enter your email address');
    }

    return {
      heading:heading,
      email:email,
      description:description,
      interest:interest,
      legal:legal,
      action:action
    };
  }

  function setupInterests(root,interestBlock){
    var inputs=Array.prototype.slice.call(root.querySelectorAll('input[name="custom_energy_interests"]'));
    if(!inputs.length)return;

    var labels=inputs.map(function(input){
      return input.closest('label')||input.parentElement;
    }).filter(Boolean);

    if(!labels.length)return;

    var sharedParent=labels[0].parentElement;
    var group=labels.every(function(label){return label.parentElement===sharedParent;})
      ?sharedParent
      :commonParent(labels);

    if(group){
      group.setAttribute('data-tm-interest-grid','');
      group.setAttribute('data-tm-interest-count',String(inputs.length));
    }

    labels.forEach(function(label,index){
      var input=inputs[index];
      var value=input.value||String(label.textContent||'').trim();
      var displayName=OPTION_ORDER.filter(function(item){
        return normalize(item)===normalize(value);
      })[0]||value;

      label.setAttribute('data-tm-interest-card',displayName);
      input.setAttribute('aria-label',displayName);

      var nativeCheckbox=input.nextElementSibling;
      if(nativeCheckbox&&!nativeCheckbox.classList.contains('tm-ref-interest-check')){
        nativeCheckbox.setAttribute('data-tm-native-checkbox','');
      }

        var icon=label.querySelector('.tm-ref-interest-icon');

      if(!icon){
        icon=document.createElement('span');
        icon.className='tm-ref-interest-icon';
        icon.setAttribute('aria-hidden','true');
        label.appendChild(icon);
      }

      if(icon.getAttribute('data-tm-icon-name')!==displayName){
        icon.innerHTML='';

        var iconUrl=ICONS[displayName];

        if(iconUrl){
          var image=document.createElement('img');
          image.className='tm-ref-interest-icon__image';
          image.src=iconUrl;
          image.alt='';
          image.width=64;
          image.height=50;
          image.decoding='async';
          image.loading='eager';
          image.setAttribute('aria-hidden','true');

          image.addEventListener('error',function(){
            icon.innerHTML=
              '<svg viewBox="0 0 72 52" aria-hidden="true">'+
                '<path d="M12 26L36 7l24 19-8 19H20z"/>'+
                '<path d="M28 45V31h16v14"/>'+
              '</svg>';
          },{once:true});

          icon.appendChild(image);
        }else{
          icon.innerHTML=
            '<svg viewBox="0 0 72 52" aria-hidden="true">'+
              '<path d="M12 26L36 7l24 19-8 19H20z"/>'+
              '<path d="M28 45V31h16v14"/>'+
            '</svg>';
        }

        icon.setAttribute('data-tm-icon-name',displayName);
      }

      var name=label.querySelector('.tm-ref-interest-name');
      if(!name){
        name=document.createElement('span');
        name.className='tm-ref-interest-name';
        name.textContent=displayName;
        label.appendChild(name);
      }else if(name.textContent!==displayName){
        name.textContent=displayName;
      }

      var check=label.querySelector('.tm-ref-interest-check');
      if(!check){
        check=document.createElement('span');
        check.className='tm-ref-interest-check';
        check.setAttribute('aria-hidden','true');
        label.appendChild(check);
      }

      Array.prototype.slice.call(label.children).forEach(function(child){
        if(child!==input&&child!==icon&&child!==name&&child!==check){
          child.setAttribute('data-tm-native-card-content','');
        }
      });

      if(!input.hasAttribute('data-tm-interest-bound')){
        input.setAttribute('data-tm-interest-bound','');
        input.addEventListener('change',function(){
          syncInterest(label,input);
        });
      }

      syncInterest(label,input);
    });

    if(group){
      var desired=labels.slice().sort(function(a,b){
        return optionIndex(a.getAttribute('data-tm-interest-card'))-optionIndex(b.getAttribute('data-tm-interest-card'));
      });
      var current=Array.prototype.slice.call(group.children).filter(function(child){
        return desired.indexOf(child)!==-1;
      });
      var same=current.length===desired.length&&current.every(function(label,index){
        return label===desired[index];
      });

      if(!same){
        desired.forEach(function(label){group.appendChild(label);});
      }
    }

    if(interestBlock){
      Array.prototype.slice.call(interestBlock.querySelectorAll('legend,label')).forEach(function(element){
        if(!element.querySelector('input[name="custom_energy_interests"]')&&normalize(element.textContent).indexOf('energy')!==-1){
          element.setAttribute('data-tm-interest-title','');
        }
      });
    }
  }

  function setupLegal(root, legalBlock) {
    var input = root.querySelector('input[name="gdpr"]');

    if (!input || !legalBlock) return;

    var label = input.closest('label') || input.parentElement;

    if (!label) return;

    label.setAttribute('data-tm-legal-label', '');

    Array.prototype.slice.call(
      legalBlock.querySelectorAll(
        '.tm-ref-legal-check, .tm-ref-consent-copy'
      )
    ).forEach(function (element) {
      element.remove();
    });

    Array.prototype.slice.call(
      legalBlock.querySelectorAll(
        '[data-tm-native-checkbox], [data-tm-native-legal-content]'
      )
    ).forEach(function (element) {
      element.removeAttribute('data-tm-native-checkbox');
      element.removeAttribute('data-tm-native-legal-content');
    });

    if (!root.hasAttribute('data-tm-legal-defaulted')) {
      root.setAttribute('data-tm-legal-defaulted', '');

      if (!input.checked) {
        input.click();
      }
    }
  }
  function enhance(){
    var root=getRoot();
    if(!root||!root.isConnected)return;

    var form=root.querySelector('form[id$="-submit-form"]')||root.querySelector('form');
    if(!form)return;

    form.setAttribute('data-tm-submit-form','');
    markPanel(root,form);

    var container=root.querySelector('.omnisend-mobile-container')||form;
    hideNativeImages(container);

    var blocks=markBlocks(root,container);
    setupInterests(root,blocks.interest);
    setupLegal(root,blocks.legal);
  }

  function schedule(){
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(function(){
      scheduled=false;
      enhance();
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',schedule,{once:true});
  }else{
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement,{
    childList:true,
    subtree:true
  });
})();
